import { CountryServiceMock } from "./country.types";

export const mockCountryService = (): CountryServiceMock => ({
  fetchCountries: jest.fn(),
});
